import type { NavigationKey } from "./navigation";

export const routePaths: Record<NavigationKey, string> = {
  operations: "/",
  incidents: "/incidents",
  assets: "/assets",
  infrastructure: "/infrastructure",
  maintenance: "/maintenance",
  vendors: "/vendors",
  knowledge: "/knowledge",
  reports: "/reports",
  administration: "/administration",
};

export function navigationFromPath(pathname: string): NavigationKey {
  const normalized = pathname !== "/" ? pathname.replace(/\/+$/, "") : pathname;
  const match = Object.entries(routePaths).find(([, path]) => path === normalized);
  return (match?.[0] as NavigationKey | undefined) ?? "operations";
}

export function pathForNavigation(key: NavigationKey): string {
  return routePaths[key];
}

export function urlForNavigation(key: NavigationKey, search = ""): string {
  return `${routePaths[key]}${search}`;
}
